import gql from 'graphql-tag';
import { CreatePerDiemFragment } from './requestPerDiemApi';

const RequestPerDiemForDateMutation = gql`
  mutation RequestPerDiemForDate($input: PerDiemRequestForDateInput!) {
    per_diem_request_for_date(input: $input) {
      ...CreatePerDiem
    }
  }
  ${CreatePerDiemFragment}
`;

export const requestPerDiemForDateApi = async (client, perDiemRequestWithDateInput) => {
  const variables = {
    input: perDiemRequestWithDateInput,
  };

  const options = {
    mutation: RequestPerDiemForDateMutation,
    variables,
  };

  const result = await client.mutate(options);
  return {
    result,
  };
};
